"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PasswordTooltip = require("./PasswordTooltip");
Object.keys(_PasswordTooltip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PasswordTooltip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PasswordTooltip[key];
    }
  });
});